var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":""}},[_c('v-flex',[_c('canvas',{attrs:{"id":"qr"}})]),_vm._t("title",function(){return [_vm._v(" QR code for this App ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }